unit Unit3;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.REST, WEBLib.JSON, WEBLib.ExtCtrls, WEBLib.DB, WEBLib.CDS,
  WEBLib.Grids, Vcl.Grids, WEBLib.DBCtrls, WEBLib.Buttons, Data.DB;

type
  TForm3 = class(TForm)
    btAbfrage: TButton;
    WebHttpRequest1: THttpRequest;
    WebLabel1: TLabel;
    edit1: TEdit;
    lbTime: TLabel;
    lbName: TLabel;
    lbWerte: TLabel;
    WebTimer1: TTimer;
    WebClientDataSet1: TClientDataSet;
    WebClientConnection1: TClientConnection;
    WebDataSource1: TDataSource;
    WebClientDataSet1id: TIntegerField;
    WebClientDataSet1name: TStringField;
    WebClientDataSet1admin: TIntegerField;
    WebDBGrid1: TDBGrid;
    WebDBLabel1: TDBLabel;
    btAdd: TButton;
    btEdit: TButton;
    btDelete: TButton;
    WebToolBar1: TToolBar;
    WebSpeedButton1: TSpeedButton;
    edAdd: TEdit;
    edVersion: TButton;
    memo: TMemo;
    WebRESTClient1: TRESTClient;
    WebHttpRequest2: THttpRequest;
    procedure btAbfrageClick(Sender: TObject);
    procedure WebTimer1Timer(Sender: TObject);
    procedure WebHttpRequest1RequestResponse(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; AResponse: string);
    procedure WebHttpRequest1Error(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
      var Handled: Boolean);
    procedure WebHttpRequest1Timeout(Sender: TObject);
    procedure btAddClick(Sender: TObject);
    procedure edVersionClick(Sender: TObject);
    procedure btEditClick(Sender: TObject);

  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    function ResolveStatusToStr(Status: TUpdateStatus): string;
    procedure PrintPendingUpdates;
  protected procedure LoadDFMValues; override; end;

var
  Form3: TForm3;

implementation

{$R *.dfm}

procedure TForm3.btAbfrageClick(Sender: TObject);
begin
  WebHttpRequest1.Headers.Clear;
  WebHttpRequest1.URL := edit1.text; //'http://localhost:1999';
  //WebHttpRequest1.URL := 'https://download.tmssoftware.com/tmsweb/music.json';
  //WebHttpRequest1.URL := 'http://92.27.68.65:7777/getRockVideos';

  WebHttpRequest1.Execute();
end;

procedure TForm3.btAddClick(Sender: TObject);
begin
  WebClientDataset1.Append;
  WebClientDataset1.FieldByName('name').AsString := edAdd.Text;
  WebClientDataset1.post;
  PrintPendingUpdates;
  WebClientDataset1.ApplyUpdates;
end;

procedure TForm3.btEditClick(Sender: TObject);
begin
  WebClientDataSet1.edit;
  WebClientDataSet1.FieldByName('name').AsString := 'Lala';
  WebClientDataSet1.post;
  PrintPendingUpdates;
  //WebClientDataSet1.ApplyUpdates;
end;

procedure TForm3.edVersionClick(Sender: TObject);
begin
  ShowMessage(application.Version);
end;

procedure TForm3.PrintPendingUpdates;
var
  ar: TResolveInfoArray;
  i: Integer;
  s : string;
begin
  ar := WebClientDataSet1.GetPendingUpdates;
  for i := 0 to High(ar) do
  begin
    s := ResolveStatusToStr(ar[i].Status);
    memo.lines.add(s + ' ' + TJSJSON.stringify(ar[i].Data));
  end;
end;

procedure TForm3.WebHttpRequest1Error(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
  var Handled: Boolean);
begin
  Weblabel1.Caption := 'Fehler bei der Übetragung';
  Handled := True;
end;

procedure TForm3.WebHttpRequest1RequestResponse(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; AResponse: string);
var
  aObj: TJSONObject;
  aArr: TJSONArray;
begin
  if ARequest.req.status = 200 then
    Weblabel1.Caption := AResponse
  else if ARequest.req.status = 404 then
    Weblabel1.Caption := 'Benutzer nicht gefunden!';

{  aObj := TJSONObject.ParseJSONValue(AResponse) as TJSONObject;
  lbTime.Caption := (aObj.GetValue('time') as TJSONString).Value;
  lbName.Caption := (aObj.GetValue('name') as TJSONString).Value;
  aArr := aObj.getValue('werte') as TJSONArray;
  liWerte.Clear;
  for i := 0 to aArr.Count - 1 do
  begin
    liWerte.Items.add((aArr[i] as TJSONString).Value);
  end; }
end;

procedure TForm3.WebHttpRequest1Timeout(Sender: TObject);
begin
  Weblabel1.Caption := 'Timeout';
end;

procedure TForm3.WebTimer1Timer(Sender: TObject);
begin
  btAbfrageClick(nil);

end;

function TForm3.ResolveStatusToStr(Status: TUpdateStatus): string;
begin
  case Status of
    usInserted: Result := 'Eingefügt';
    usModified: Result := 'Geändert';
    usDeleted: Result := 'Gelöscht';
  else
    Result := 'Unbekannt';
  end;
end;

procedure TForm3.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  lbTime := TLabel.Create(Self);
  lbName := TLabel.Create(Self);
  lbWerte := TLabel.Create(Self);
  WebDBLabel1 := TDBLabel.Create(Self);
  btAbfrage := TButton.Create(Self);
  edit1 := TEdit.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  btAdd := TButton.Create(Self);
  btEdit := TButton.Create(Self);
  btDelete := TButton.Create(Self);
  WebToolBar1 := TToolBar.Create('');
  WebSpeedButton1 := TSpeedButton.Create(Self);
  edAdd := TEdit.Create(Self);
  edVersion := TButton.Create(Self);
  memo := TMemo.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  WebTimer1 := TTimer.Create(Self);
  WebClientDataSet1 := TClientDataSet.Create(Self);
  WebClientDataSet1id := TIntegerField.Create(Self);
  WebClientDataSet1name := TStringField.Create(Self);
  WebClientDataSet1admin := TIntegerField.Create(Self);
  WebClientConnection1 := TClientConnection.Create(Self);
  WebDataSource1 := TDataSource.Create(Self);
  WebRESTClient1 := TRESTClient.Create(Self);
  WebHttpRequest2 := THttpRequest.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  lbTime.BeforeLoadDFMValues;
  lbName.BeforeLoadDFMValues;
  lbWerte.BeforeLoadDFMValues;
  WebDBLabel1.BeforeLoadDFMValues;
  btAbfrage.BeforeLoadDFMValues;
  edit1.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  btAdd.BeforeLoadDFMValues;
  btEdit.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  WebToolBar1.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  edAdd.BeforeLoadDFMValues;
  edVersion.BeforeLoadDFMValues;
  memo.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  WebClientDataSet1.BeforeLoadDFMValues;
  WebClientDataSet1id.BeforeLoadDFMValues;
  WebClientDataSet1name.BeforeLoadDFMValues;
  WebClientDataSet1admin.BeforeLoadDFMValues;
  WebClientConnection1.BeforeLoadDFMValues;
  WebDataSource1.BeforeLoadDFMValues;
  WebRESTClient1.BeforeLoadDFMValues;
  WebHttpRequest2.BeforeLoadDFMValues;
  try
    Name := 'Form3';
    Width := 640;
    Height := 480;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 24;
    WebLabel1.Top := 88;
    WebLabel1.Width := 58;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'WebLabel1';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    lbTime.SetParentComponent(Self);
    lbTime.Name := 'lbTime';
    lbTime.Left := 24;
    lbTime.Top := 128;
    lbTime.Width := 26;
    lbTime.Height := 15;
    lbTime.Caption := 'Time';
    lbTime.HeightPercent := 100.000000000000000000;
    lbTime.WidthPercent := 100.000000000000000000;
    lbName.SetParentComponent(Self);
    lbName.Name := 'lbName';
    lbName.Left := 24;
    lbName.Top := 152;
    lbName.Width := 32;
    lbName.Height := 15;
    lbName.Caption := 'Name';
    lbName.HeightPercent := 100.000000000000000000;
    lbName.WidthPercent := 100.000000000000000000;
    lbWerte.SetParentComponent(Self);
    lbWerte.Name := 'lbWerte';
    lbWerte.Left := 24;
    lbWerte.Top := 176;
    lbWerte.Width := 31;
    lbWerte.Height := 15;
    lbWerte.Caption := 'Werte';
    lbWerte.HeightPercent := 100.000000000000000000;
    lbWerte.WidthPercent := 100.000000000000000000;
    WebDBLabel1.SetParentComponent(Self);
    WebDBLabel1.Name := 'WebDBLabel1';
    WebDBLabel1.Left := 176;
    WebDBLabel1.Top := 320;
    WebDBLabel1.Width := 73;
    WebDBLabel1.Height := 15;
    WebDBLabel1.Caption := 'WebDBLabel1';
    WebDBLabel1.HeightPercent := 100.000000000000000000;
    WebDBLabel1.WidthPercent := 100.000000000000000000;
    WebDBLabel1.DataField := 'name';
    WebDBLabel1.DataSource := WebDataSource1;
    btAbfrage.SetParentComponent(Self);
    btAbfrage.Name := 'btAbfrage';
    btAbfrage.Left := 24;
    btAbfrage.Top := 44;
    btAbfrage.Width := 96;
    btAbfrage.Height := 25;
    btAbfrage.Caption := 'Abfrage';
    btAbfrage.HeightPercent := 100.000000000000000000;
    btAbfrage.WidthPercent := 100.000000000000000000;
    SetEvent(btAbfrage, Self, 'OnClick', 'btAbfrageClick');
    edit1.SetParentComponent(Self);
    edit1.Name := 'edit1';
    edit1.Left := 24;
    edit1.Top := 16;
    edit1.Width := 233;
    edit1.Height := 22;
    edit1.ChildOrder := 2;
    edit1.HeightPercent := 100.000000000000000000;
    edit1.Text := 'http://localhost:1999/time';
    edit1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.SetParentComponent(Self);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 328;
    WebDBGrid1.Top := 152;
    WebDBGrid1.Width := 241;
    WebDBGrid1.Height := 142;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'name';
      Title := 'Name';
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'admin';
      Editor := geNumber;
      Title := 'Admin';
    end;
    WebDBGrid1.DataSource := WebDataSource1;
    WebDBGrid1.ElementFont := efCSS;
    WebDBGrid1.FixedFont.Charset := DEFAULT_CHARSET;
    WebDBGrid1.FixedFont.Color := clWindowText;
    WebDBGrid1.FixedFont.Height := -12;
    WebDBGrid1.FixedFont.Name := 'Segoe UI';
    WebDBGrid1.FixedFont.Style := [];
    WebDBGrid1.FixedCols := 1;
    WebDBGrid1.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goRowSelect,goFixedRowDefAlign];
    WebDBGrid1.TabOrder := 2;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.ColWidths[0] := 24;
    WebDBGrid1.ColWidths[1] := 64;
    WebDBGrid1.ColWidths[2] := 64;
    WebDBGrid1.RowHeights[0] := 22;
    WebDBGrid1.RowHeights[1] := 22;
    WebDBGrid1.RowHeights[2] := 22;
    WebDBGrid1.RowHeights[3] := 22;
    WebDBGrid1.RowHeights[4] := 22;
    btAdd.SetParentComponent(Self);
    btAdd.Name := 'btAdd';
    btAdd.Left := 369;
    btAdd.Top := 300;
    btAdd.Width := 56;
    btAdd.Height := 25;
    btAdd.Caption := 'Add';
    btAdd.ChildOrder := 9;
    btAdd.HeightPercent := 100.000000000000000000;
    btAdd.WidthPercent := 100.000000000000000000;
    SetEvent(btAdd, Self, 'OnClick', 'btAddClick');
    btEdit.SetParentComponent(Self);
    btEdit.Name := 'btEdit';
    btEdit.Left := 431;
    btEdit.Top := 300;
    btEdit.Width := 56;
    btEdit.Height := 25;
    btEdit.Caption := 'Edit';
    btEdit.ChildOrder := 9;
    btEdit.HeightPercent := 100.000000000000000000;
    btEdit.WidthPercent := 100.000000000000000000;
    SetEvent(btEdit, Self, 'OnClick', 'btEditClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 493;
    btDelete.Top := 300;
    btDelete.Width := 56;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.ChildOrder := 9;
    btDelete.HeightPercent := 100.000000000000000000;
    btDelete.WidthPercent := 100.000000000000000000;
    WebToolBar1.SetParentComponent(Self);
    WebToolBar1.Name := 'WebToolBar1';
    WebToolBar1.Left := 284;
    WebToolBar1.Top := 8;
    WebToolBar1.Width := 300;
    WebToolBar1.Height := 32;
    WebToolBar1.ElementClassName := '';
    WebSpeedButton1.SetParentComponent(WebToolBar1);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 8;
    WebSpeedButton1.Top := 4;
    WebSpeedButton1.Width := 24;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := 'WebSpeedButton1';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    edAdd.SetParentComponent(Self);
    edAdd.Name := 'edAdd';
    edAdd.Left := 176;
    edAdd.Top := 341;
    edAdd.Width := 121;
    edAdd.Height := 22;
    edAdd.ChildOrder := 13;
    edAdd.HeightPercent := 100.000000000000000000;
    edAdd.WidthPercent := 100.000000000000000000;
    edVersion.SetParentComponent(Self);
    edVersion.Name := 'edVersion';
    edVersion.Left := 369;
    edVersion.Top := 340;
    edVersion.Width := 56;
    edVersion.Height := 25;
    edVersion.Caption := 'Version';
    edVersion.ChildOrder := 9;
    edVersion.HeightPercent := 100.000000000000000000;
    edVersion.WidthPercent := 100.000000000000000000;
    SetEvent(edVersion, Self, 'OnClick', 'edVersionClick');
    memo.SetParentComponent(Self);
    memo.Name := 'memo';
    memo.Left := 8;
    memo.Top := 197;
    memo.Width := 162;
    memo.Height := 148;
    memo.HeightPercent := 100.000000000000000000;
    memo.Lines.BeginUpdate;
    try
      memo.Lines.Clear;
      memo.Lines.Add('memo');
    finally
      memo.Lines.EndUpdate;
    end;
    memo.SelLength := 0;
    memo.SelStart := 0;
    memo.WidthPercent := 100.000000000000000000;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    SetEvent(WebHttpRequest1, Self, 'OnError', 'WebHttpRequest1Error');
    SetEvent(WebHttpRequest1, Self, 'OnRequestResponse', 'WebHttpRequest1RequestResponse');
    SetEvent(WebHttpRequest1, Self, 'OnTimeout', 'WebHttpRequest1Timeout');
    WebHttpRequest1.Left := 168;
    WebHttpRequest1.Top := 128;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Enabled := False;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 168;
    WebTimer1.Top := 64;
    WebClientDataSet1.SetParentComponent(Self);
    WebClientDataSet1.Name := 'WebClientDataSet1';
    WebClientDataSet1.Connection := WebClientConnection1;
    WebClientDataSet1.Left := 40;
    WebClientDataSet1.Top := 372;
    WebClientDataSet1id.SetParentComponent(WebClientDataSet1);
    WebClientDataSet1id.Name := 'WebClientDataSet1id';
    WebClientDataSet1id.FieldName := 'id';
    WebClientDataSet1name.SetParentComponent(WebClientDataSet1);
    WebClientDataSet1name.Name := 'WebClientDataSet1name';
    WebClientDataSet1name.FieldName := 'name';
    WebClientDataSet1name.Size := 256;
    WebClientDataSet1admin.SetParentComponent(WebClientDataSet1);
    WebClientDataSet1admin.Name := 'WebClientDataSet1admin';
    WebClientDataSet1admin.FieldName := 'admin';
    WebClientConnection1.SetParentComponent(Self);
    WebClientConnection1.Name := 'WebClientConnection1';
    WebClientConnection1.Active := False;
    WebClientConnection1.Delimiter := ';';
    WebClientConnection1.Left := 168;
    WebClientConnection1.Top := 372;
    WebDataSource1.SetParentComponent(Self);
    WebDataSource1.Name := 'WebDataSource1';
    WebDataSource1.DataSet := WebClientDataSet1;
    WebDataSource1.Left := 300;
    WebDataSource1.Top := 372;
    WebRESTClient1.SetParentComponent(Self);
    WebRESTClient1.Name := 'WebRESTClient1';
    WebRESTClient1.LoginHeight := 0;
    WebRESTClient1.LoginWidth := 0;
    WebRESTClient1.Left := 248;
    WebRESTClient1.Top := 248;
    WebHttpRequest2.SetParentComponent(Self);
    WebHttpRequest2.Name := 'WebHttpRequest2';
    WebHttpRequest2.Left := 296;
    WebHttpRequest2.Top := 192;
  finally
    WebLabel1.AfterLoadDFMValues;
    lbTime.AfterLoadDFMValues;
    lbName.AfterLoadDFMValues;
    lbWerte.AfterLoadDFMValues;
    WebDBLabel1.AfterLoadDFMValues;
    btAbfrage.AfterLoadDFMValues;
    edit1.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    btAdd.AfterLoadDFMValues;
    btEdit.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    WebToolBar1.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    edAdd.AfterLoadDFMValues;
    edVersion.AfterLoadDFMValues;
    memo.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
    WebClientDataSet1.AfterLoadDFMValues;
    WebClientDataSet1id.AfterLoadDFMValues;
    WebClientDataSet1name.AfterLoadDFMValues;
    WebClientDataSet1admin.AfterLoadDFMValues;
    WebClientConnection1.AfterLoadDFMValues;
    WebDataSource1.AfterLoadDFMValues;
    WebRESTClient1.AfterLoadDFMValues;
    WebHttpRequest2.AfterLoadDFMValues;
  end;
end;

end.